<template>
  <div class="sc-wizardsteps-outer-container" :ref="componentRef">
    <div class="sc-wizardsteps-default-bg"></div>
    <div
      class="sc-wizardsteps-gradient-bg-container"
      :style="{ width: gradientBgWidthPercent + '%' }">
      <div
        class="sc-wizardsteps-gradient-bg">
      </div>
      <div
        v-if="active !== steps.length - 1"
        class="sc-wizardsteps-gradient-arrow"
        :style="{ width: arrowDivSide + 'px',
                  height: arrowDivSide + 'px',
                  top: (wizardHeight - arrowDivSide) / 2 + 'px',
                  right: arrowDivSide / -2 + 'px' }">
      </div>
    </div>
    <div
      class="sc-wizardsteps-inner-container">
      <div :style="{ width: itemWidthPercent + '%' }"></div>
      <div
        v-for="(item, index) of steps"
        class="sc-wizardsteps-items-container"
        :style="{ width: itemWidthPercent + '%' }"
        :key="index"
        @click="onClick(index)">
        <div class="sc-wizardsteps-items">
          <div
            class="sc-wizardsteps-item"
            :class="{ 'sc-wizardsteps-step-done': index < active,
                      'sc-wizardsteps-active-item': index === active }">
              {{ item }}
          </div>
          <i
            v-if="!(index === active || index === steps.length - 1)"
            class="sc-icon-chevron-right sc-wizardsteps-arrow-icon">
          </i>
        </div>
      </div>
      <div :style="{ width: itemWidthPercent + '%' }"></div>
    </div>
  </div>
</template>

<script>
import utilsMixin from '../mixins/utils'

export default {
  name: 'ScWizardSteps',
  mixins: [utilsMixin],
  props: {
    steps: {
      type: Array,
      required: true
    },
    active: {
      type: Number,
      default: 0
    }
  },
  watch: {
    active () {
      this.callCounterFunctions()
    }
  },
  data () {
    return {
      componentRef: null,
      itemWidthPercent: null,
      gradientBgWidthPercent: null,
      wizardHeight: null,
      arrowDivSide: null
    }
  },
  mounted () {
    this.initData()
    this.watchWindowSizeChanges()
  },
  methods: {
    initData () {
      this.componentRef = this.generateId()
      this.itemWidthPercent = 100 / (this.steps.length + 2)
      this.callCounterFunctions()
    },
    watchWindowSizeChanges () {
      window.addEventListener('resize', () => {
        this.callCounterFunctions()
      })
    },
    callCounterFunctions () {
      setTimeout(() => {
        this.countGradientBgPercent()
        this.countWizardAndArrowHeight()
      })
    },
    countGradientBgPercent () {
      if (this.active === this.steps.length - 1) {
        this.gradientBgWidthPercent = 100
      } else {
        this.gradientBgWidthPercent = this.itemWidthPercent * (this.active + 1) + this.itemWidthPercent * 0.9
      }
    },
    countWizardAndArrowHeight () {
      const wizard = this.$refs[this.componentRef]
      const heightString = window.getComputedStyle(wizard, null).height
      this.wizardHeight = parseInt(heightString.substring(0, heightString.length - 2))
      this.arrowDivSide = Math.sqrt(Math.pow(this.wizardHeight, 2) / 2)
    },

    onClick (index) {
      this.$emit('click', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.sc-wizardsteps-outer-container {
  width: 100%;
  position: relative;
  display: inline-flex;
  font-size: $sc-wizardsteps-font-size;
}
.sc-wizardsteps-inner-container {
  width: 100%;
  display: inline-flex;
}
.sc-wizardsteps-items-container {
  background-color: transparent;
  z-index: 3;
  padding: $sc-wizardsteps-items-padding;
}
.sc-wizardsteps-items {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.sc-wizardsteps-item {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $sc-wizardsteps-color;
  user-select: none;
}
.sc-wizardsteps-active-item {
  font-weight: $sc-wizardsteps-font-weight-active;
  color: $sc-wizardsteps-color-active;
  width: 90%;
  padding-right: 10px;
}
.sc-wizardsteps-arrow-icon {
  color: $sc-primary;
  font-size: $sc-wizardsteps-arrow-font-size;
}
.sc-wizardsteps-step-done {
  color: $sc-wizardsteps-color-done;
}
.sc-wizardsteps-gradient-arrow {
  mix-blend-mode: color;
  position: absolute;
  background-color: $sc-wizardsteps-end-color;
  transform: rotate(45deg);
  z-index: 3;
}
.sc-wizardsteps-default-bg {
  position: absolute;
  z-index: 1;
  background-color: $sc-wizardsteps-future-step-bg;
  width: 100%;
  height: 100%;
}
.sc-wizardsteps-gradient-bg {
  background-image: linear-gradient(to right, $sc-wizardsteps-start-color, $sc-wizardsteps-end-color);
  height: 100%;
  width: 100%;
  z-index: 4;
}
.sc-wizardsteps-gradient-bg-container {
  position: absolute;
  height: 100%;
  z-index: 2;
}
</style>
